import React from "react";
import Modal from "../common/Modal";
import { Link } from "react-router-dom";
import termsImage from "../../images/Terms & Conditions.webp";
import styles from "./TermsConditionsModal.module.scss";

const termsCards = [
  {
    number: "1",
    icon: "🛡️",
    title: "Eligibility and Business Use",
    content:
      "Munafa Engine is intended primarily for business use, especially by salon owners, salon operators, managers, or authorised representatives seeking structured weekly visibility into business performance.",
  },
  {
    number: "2",
    icon: "📘",
    title: "Definitions",
    content:
      "For the purpose of these Terms: Platform means the Munafa Engine website, webapp, mobile app, forms, dashboards, report interfaces, and related digital systems.",
  },
  {
    number: "3",
    icon: "📊",
    title: "Nature of the Services",
    content:
      "Munafa Engine provides structured business-clarity and decision-support services.",
  },
  {
    number: "4",
    icon: "⚖️",
    title: "What Munafa Engine Does Not Provide",
    content:
      "Munafa Engine does not provide statutory audit services, legal advice, or guaranteed business outcomes.",
  },
  {
    number: "5",
    icon: "📈",
    title: "No Guarantee of Outcomes",
    content:
      "Munafa Engine does not guarantee profit growth, revenue growth, or business turnaround.",
  },
  {
    number: "6",
    icon: "🗂️",
    title: "Client Responsibility for Data",
    content:
      "You are solely responsible for the correctness and completeness of data shared.",
  },
  {
    number: "7",
    icon: "🔍",
    title:
      "Limited Reliance and Professional Boundaries",
    content:
      "Outputs should not be treated as statutory opinion, legal advice, or investment recommendation.",
  },
  {
    number: "8",
    icon: "🔐",
    title:
      "Accounts, Login Access, and Credentials",
    content:
      "You are responsible for keeping your login credentials secure.",
  },
  {
    number: "9",
    icon: "💻",
    title:
      "Device, Connectivity, and Technical Responsibility",
    content:
      "You are responsible for ensuring compatible devices and stable internet connectivity.",
  },
  {
    number: "10",
    icon: "⚙️",
    title:
      "Platform Availability, Updates, and Feature Changes",
    content:
      "The Platform may be updated, modified, improved, paused, or restructured from time to time.",
  },
  {
    number: "11",
    icon: "📩",
    title:
      "Communications, Alerts, and Electronic Consent",
    content:
      "You consent to communication through email, WhatsApp, SMS, notifications, and related digital channels.",
  },
  {
    number: "12",
    icon: "📄",
    title:
      "Lead Forms, Review Requests, and Acceptance of Work",
    content:
      "Submitting a form or enquiry does not automatically create a binding service relationship.",
  },
  {
    number: "13",
    icon: "💳",
    title: "Payments, Pricing, and Billing",
    content:
      "Payments are made for the selected service scope and effort, not for guaranteed outcomes.",
  },
  {
    number: "14",
    icon: "↩️",
    title: "Refunds and Cancellations",
    content:
      "Refunds and cancellations are governed by our Refund & Cancellation Policy.",
  },
  {
    number: "15",
    icon: "🚫",
    title:
      "Acceptable Use of Website, Webapp, and Mobile App",
    content:
      "You agree not to misuse the Platform or attempt unauthorised access.",
  },
  {
    number: "16",
    icon: "©️",
    title: "Intellectual Property",
    content:
      "All rights in the Munafa Engine brand and platform belong to Munafa Engine.",
  },
  {
    number: "17",
    icon: "📁",
    title: "Ownership of Client Data",
    content:
      "You retain ownership of your raw business information shared with us.",
  },
  {
    number: "18",
    icon: "🤝",
    title: "Confidentiality",
    content:
      "We handle client business information with reasonable care and confidentiality.",
  },
  {
    number: "19",
    icon: "🔒",
    title:
      "Privacy and Personal Information",
    content:
      "Your use of the Platform and Services is governed by our Privacy Policy.",
  },
  {
    number: "20",
    icon: "🌐",
    title:
      "Third-Party Platforms, App Stores, and Service Providers",
    content:
      "We may use third-party hosting, analytics, communication, and payment providers.",
  },
  {
    number: "21",
    icon: "⛔",
    title:
      "Suspension, Restriction, and Termination",
    content:
      "We may suspend or terminate access where misuse or legal risk is identified.",
  },
  {
    number: "22",
    icon: "⚠️",
    title: "No Warranty",
    content:
      "The Platform and Services are provided on an as-is and as-available basis.",
  },
  {
    number: "23",
    icon: "🧾",
    title: "Limitation of Liability",
    content:
      "Munafa Engine shall not be liable for indirect or consequential losses.",
  },
  {
    number: "24",
    icon: "🛡️",
    title: "Indemnity",
    content:
      "You agree to indemnify Munafa Engine against claims arising from misuse.",
  },
  {
    number: "25",
    icon: "🌩️",
    title: "Force Majeure",
    content:
      "We are not liable for delays caused by events beyond reasonable control.",
  },
  {
    number: "26",
    icon: "🏛️",
    title:
      "Governing Law and Jurisdiction",
    content:
      "These Terms shall be governed by the laws of India.",
  },
  {
    number: "27",
    icon: "🔄",
    title: "Changes to These Terms",
    content:
      "We may update these Terms from time to time.",
  },
  {
    number: "28",
    icon: "📌",
    title: "Severability",
    content:
      "If any provision is held invalid, remaining provisions shall continue.",
  },
  {
    number: "29",
    icon: "📚",
    title: "Entire Understanding",
    content:
      "These Terms together with our policies form the governing framework.",
  },
  {
    number: "30",
    icon: "📞",
    title: "Contact Details",
    content:
      "For questions regarding these Terms contact connect@munafaengine.com",
  },
  {
    number: "31",
    icon: "✅",
    title: "Final Acknowledgement",
    content:
      "By using our Services, you confirm you have read and agreed to these Terms.",
  },
];

export default function TermsConditionsModal({
  isOpen,
  onClose,
  onOpenPrivacy,
  onOpenRefund
}) {
  const scrollToClause = (id) => {
    const element = document.getElementById(id);

    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className={styles.termsModal}>

        <div className={styles.mainContent}>

          {/* LEFT */}
          <div className={styles.leftSection}>

            <div className={styles.badge}>
              LEGAL PAGE
            </div>

            <h1 className={styles.heroTitle}>
              Terms & Conditions
            </h1>

            <div className={styles.orangeLine}></div>

            <p className={styles.description}>
              These Terms & Conditions govern your
              access to and use of the Munafa Engine
              website, web application, mobile
              application, forms, dashboards,
              reports, communication channels, and
              related services.
            </p>

            <p className={styles.description}>
              By using the Platform or Services, you
              agree to be bound by these Terms, our
              Privacy Policy, and our Refund &
              Cancellation Policy.
            </p>

            {/* QUICK NAVIGATION */}
            <div className={styles.quickCard}>

              <div className={styles.quickHeader}>
                <h3>Quick Navigation</h3>

                <span>31 Clauses</span>
              </div>

              <div className={styles.quickGrid}>
                {termsCards.map((item, index) => (
                  <button
                    key={index}
                    className={styles.quickItem}
                    onClick={() =>
                      scrollToClause(
                        `clause-${item.number}`
                      )
                    }
                  >
                    <span>
                      {item.number.padStart(
                        2,
                        "0"
                      )}
                    </span>

                    <p>{item.title}</p>
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* RIGHT */}
          <div className={styles.rightSection}>

            {/* IMAGE */}
            <div className={styles.imageWrapper}>
              <img
                src={termsImage}
                alt="Terms"
                className={styles.heroImage}
               loading="lazy" decoding="async"/>
            </div>

            {/* TERMS */}
            <div className={styles.cards}>
              {termsCards.map((item, index) => (
                <div
                  key={index}
                  id={`clause-${item.number}`}
                  className={styles.termCard}
                >
                  <div className={styles.cardIcon}>
                    <span>{item.icon}</span>
                  </div>

                  <div className={styles.cardContent}>
                    <h4>
                      {item.number}. {item.title}
                    </h4>

                    <p>{item.content}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className={styles.bottomBar}>
              All 31 clauses are part of the
              governing legal framework of Munafa
              Engine.
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <div className={styles.footer}>

          <div className={styles.footerLeft}>
            🔒 Your data is private, secure, and
            never shared.
          </div>

          <div className={styles.footerLinks}>
            <button
              onClick={onOpenPrivacy}
              className={styles.navLink}
            >
              Privacy Policy
            </button>

            <button
              onClick={onOpenRefund}
              className={styles.navLink}
            >
              Refund & Cancellation Policy
            </button>
          </div>

          <div className={styles.footerCopy}>
            © 2026 Munafa Engine. All rights
            reserved.
          </div>
        </div>
      </div>
    </Modal>
  );
}